import AuthMixin from '@/components/mixins/auth-mixin'
import PlayerMixin from '@/components/mixins/player-mixin'
import OnEnterMixin from '../../mixins/onenter-mixin'
import GoogleMap from '@/components/common/google-map/google-map-tmpl'
import TagsMenuItem from '@/components/common/tags/tags-tmpl'
import TagSlider from '@/components/common/tag-slider/tag-slider-tmpl'
import { getCustomIconUrl } from '@/components/common/google-map/google-map-markers'
import CONST from '@/globals/constants'
import { mapActions, mapState } from 'pinia'
import { monitoringPlayerStore } from '@/pinia/stores/playersStore'

export default {
  name: 'monitoringPage',
  inject: [
    '$utils',
    '$dataStore',
    '$api',
    '$apiError'
  ],
  components: {
    GoogleMap,
    TagsMenuItem,
    TagSlider
  },
  props: {
    dataProp: {
      type: String,
      default () { return '' }
    },
    isActive: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    dataProp (val) {
      this.dataPropVal = val
    },
    selectedMarker () {
      $(window).on('resize', () => { this.$utils.updatePageComponentStyle({ name: 'monitoringPage' }) })
    },
    doneFetchingAllPlayers (newVal) {
      this.$utils.mainLoader(!newVal);
    },
    playerStoreError (newVal) {
      if (newVal) {
        this.$apiError.handleAPIRequestError(newVal, { showDialogNotification: true })
      }
    }
  },
  computed: {
    ...mapState(monitoringPlayerStore, {
      playerStoreError: 'error',
      rawPlayersList: 'players',
      doneFetchingAllPlayers: (stage) => !stage.isFetching,
    }),
    allPlayers () {
      return this.filterPlayers(this.rawPlayersList);
    }
  },
  mixins: [AuthMixin, PlayerMixin, OnEnterMixin],
  data () {
    return {
      CONST,
      title: 'aside-layout-structure-page',
      dataPropVal: this.dataProp,
      showSearchInput: false,
      playersToShow: [],
      countVisiblePlayersStatusIcon: {
        summary: { green: null, orange: null, red: null }, // Always follow this order
        hasSelectedMarker: false
      },
      countVisiblePlayers: 0,
      selectedMarker: null,
      showPlayerInfo: false,
      addressSearchBox: null,
      showPlayersAddressSearchBox: false,
      playersAddressSearchBoxEl: null,
      playersAddressSearchBox: null,
      playerSelection: this.playerSelectionProp,
      allLEDTags: [],
      playerAllTags: [],
      playerNormalTags: [],
      playerLEDTags: [],
      showResolutionOptionProp: false,
      hideResolutionLessThanLedDimension: false,
      optionPropertyIds: {
        serialNumber: 'serialNumber',
        firmwareVersion: 'firmwareVersion',
        playerName: 'playerName',
        playerTag: 'playerTag',
        status: 'status',
        resolution: 'resolution',
        led: 'led',
        audio: 'audio',
        address: 'address'
      },
      optionProperties: [
        {
          id: 'playerName',
          name: this.$t('label.name', 1),
          editable: true
        },
        {
          id: 'serialNumber',
          name: this.$t('label.serialNumber'),
          editable: true
        },
        {
          id: 'firmwareVersion',
          name: this.$t('label.firmware'),
          editable: true
        },
        {
          id: 'address',
          name: this.$t('label.address'),
          editable: true
        },
        {
          id: 'status',
          name: this.$t('label.status'),
          editable: true
        }
      ],
      resolutionOptions: {
        optionsA: [{ label: '720p', value: '1280x720' }, { label: '1080p', value: '1920x1080' }],
        optionsB: [{ label: 'HD', value: '1920x1080' }, { label: '4K', value: '3840x2160' }]
      },
      resolutionOptionsKey: 'optionsA',
      selectedResolution: null,
      resolutionDefaultValContent: this.$t('label.resolution'),
      showResolutionOptionContent: false,
      audioOptions: {
        optionsA: [
          { label: 'none', value: JSON.stringify({ 'enable-audio': false, 'audio-power-save': false, 'audio-output': 'hdmi' }) },
          { label: 'HDMI', value: JSON.stringify({ 'enable-audio': true, 'audio-power-save': true, 'audio-output': 'hdmi' }) },
          { label: 'line out', value: JSON.stringify({ 'enable-audio': true, 'audio-power-save': true, 'audio-output': 'jack' }) }
        ],
        optionsB: []
      },
      audioOptionsKey: 'optionsA',
      showAudioOptionProp: false,
      showAudioOptionContent: false,
      selectedAudioVal: null,
      audioDefaultValContent: this.$t('label.audio'),
      playerSearchTextVal: '',
      idleTimeSearchingVal: 2000, // 2 seconds,,
      searchPlayerInMap: {
        textVal: null,
        ref: null
      },
      tagsSummary: [],
      playerTags: [],
      doneFetchingTags: false,
      prevPlayerSearchText: null,
      tagsSelectionRequest: { ref: null, tags: [], default: false },
      filterPlayerByIconColor: false,
      playersToShowBeforePlayerStatusFilter: [],
      visiblePlayersInMap: [],
      playersAddressChangedProp: {
        ref: null,
        player: null
      }
    }
  },
  methods: {
    ...mapActions(monitoringPlayerStore, {
      loadAllPlayers: 'loadAll',
      updatePlayersList: 'updatePlayersList'
    }),
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('structure-layout-change', { action, payload: { data } })
      }
    },
    createPlayersAddressSearchBox () {
      this.playersAddressSearchBoxEl = document.getElementById('playersAddressSearchBox')
      this.playersAddressSearchBox = new window.google.maps.places.SearchBox(this.playersAddressSearchBoxEl)

      this.playersAddressSearchBox.addListener('places_changed', () => {
        const places = this.playersAddressSearchBox.getPlaces().length ? this.playersAddressSearchBox.getPlaces()[0] : null

        if (places && places.geometry) {
          const acceptedTypeForCountry = ['country']
          const acceptedTypeForStreet = ['route']
          const acceptedTypeForStreetNumber = ['street_number']
          const acceptedTypeForPostalCode = ['postal_code']
          const address = {
            city: '',
            countryName: '',
            countryCode: '',
            postalCode: '',
            street: '',
            streetNumber: '',
            latitude: places.geometry.location.lat(),
            longitude: places.geometry.location.lng()
          }

          places.address_components.forEach((addressComponent) => {
            if (addressComponent.types) {
              for (const indx in addressComponent.types) {
                const addressCompType = addressComponent.types[indx]

                // City
                if (address.city === '') {
                  if (addressCompType === 'sublocality') {
                    address.city = addressComponent.short_name
                  } else if (addressCompType === 'locality') {
                    address.city = addressComponent.short_name
                  } else if (addressCompType === 'postal_town') {
                    address.city = addressComponent.short_name
                  }
                }

                // Street
                if (acceptedTypeForStreet.indexOf(addressCompType) >= 0) {
                  address.street = addressComponent.long_name
                }

                // Street Number
                if (acceptedTypeForStreetNumber.indexOf(addressCompType) >= 0) {
                  address.streetNumber = addressComponent.long_name
                }

                // Country and Country code
                if (acceptedTypeForCountry.indexOf(addressCompType) >= 0) {
                  address.countryName = addressComponent.long_name
                  address.countryCode = addressComponent.short_name
                }

                // Postal Code
                if (acceptedTypeForPostalCode.indexOf(addressCompType) >= 0) {
                  address.postalCode = addressComponent.long_name
                }
              }
            }
          })

          this.updatePlayer({
            payload: { address },
            serialNumber: this.selectedMarker.markerData.playersInfo.serialNumber
          })
        }
      })

      this.playersAddressSearchBoxEl.addEventListener('blur', ($event) => {
        this.showPlayersAddressSearchBox = false
      })
    },
    playersStatusSummaryIconClick (params) {
      if (this.countVisiblePlayersStatusIcon.hasSelectedMarker) return

      this.filterPlayerByIconColor = false
      if (!params.all) {
        this.filterPlayerByIconColor = params.status
      }

      const countVisiblePlayersStatusIcon = this.$utils.clone(this.countVisiblePlayersStatusIcon)
      for (const indx in countVisiblePlayersStatusIcon.summary) {
        const statusIcon = countVisiblePlayersStatusIcon.summary[indx]

        if (statusIcon) {
          statusIcon.iconSrc = statusIcon.iconSrcDefault
          statusIcon.selected = false

          if (statusIcon.status === params.status) {
            statusIcon.iconSrc = statusIcon.iconSrcSelected
            statusIcon.selected = true
          }
        }
      }

      this.countVisiblePlayersStatusIcon = countVisiblePlayersStatusIcon
    },
    handleSearchIconClick () {
      if (!this.showSearchInput) {
        this.showSearchInput = true
        this.$nextTick(_ => { this.$refs.monitoringPlayerSearchInput.focus() })
      } else {
        this.showSearchInput = false
      }
    },
    handleEditPlayersAddressClick () {
      this.showPlayersAddressSearchBox = true
      this.$nextTick(_ => { this.$refs.playersAddressSearchBox[0].focus() })
    },
    handleGoogleMapChange ($event) {
      if ($event.action === 'VISIBLE_MARKERS_CHANGED') {
        this.showfPlayerInfo = false
        this.createVisibleMarkersSummary($event.payload.data)
      } else if ($event.action === 'MARKER_GROUP_BY_THE_SAME_LOCATION_CLICKED') {
        this.createVisibleMarkersSummary({ markerSelected: true, visibleMarkers: $event.payload.data })
      } else if ($event.action === 'MARKER_SELECTED') {
        this.handleSelectedPlayerInfo($event.payload.data)
        this.$nextTick(_ => { this.createPlayersAddressSearchBox() })
      } else if ($event.action === 'PLAYERS_PREVIEW_CLOSED') {
        this.showPlayerInfo = false
      }
    },
    handleSelectedPlayerInfo (selectedMarkerSrc) {
      this.selectedMarker = selectedMarkerSrc
      this.showPlayerInfo = !this.selectedMarker.markerData.groupId
      const player = this.selectedMarker.markerData.playersInfo

      // Set Normal Tags and LED TAGS
      const tagSummary = player.tags ? player.tags : []
      this.playerAllTags = tagSummary
      this.playerNormalTags = this.playerAllTags.filter((tag) => { return !tag.includes('LED:') })
      const playerLEDTags = this.playerAllTags.filter((tag) => { return tag.includes('LED:') })
      this.playerLEDTags = playerLEDTags

      // Set group
      const groupAPlayerType = ['DiVA', 'HMP300', 'HMP350']
      const groupBPlayerType = ['DSOS', 'HMP400', 'HMP400W', 'iBX440', 'iBX410', 'iBX410W']

      // Set resolution options
      const hasOptionsA = groupAPlayerType.indexOf(player.deviceType) >= 0
      const hasOptionsB = groupBPlayerType.indexOf(player.deviceType) >= 0
      let showResolutionOptionPropVal = false
      let resolutionOptionsKeyVal = null

      if (hasOptionsA && !hasOptionsB) {
        showResolutionOptionPropVal = true
        resolutionOptionsKeyVal = 'optionsA'
      } else if (!hasOptionsA && hasOptionsB) {
        showResolutionOptionPropVal = true
        resolutionOptionsKeyVal = 'optionsB'
      }

      this.showResolutionOptionProp = showResolutionOptionPropVal
      this.resolutionOptionsKey = resolutionOptionsKeyVal

      // Set resolution default value
      if (this.showResolutionOptionProp) {
        const resolutionSummary = []
        if (player.config && player.config['display-video-mode']) {
          resolutionSummary.push(player.config['display-video-mode'].resolution)
        }

        this.selectedResolution = resolutionSummary[0]
      }

      // Set Audio Default value and Options for group A
      this.audioOptionsKey = 'optionsA'

      const audioSummary = []
      const audioSettings = {}
      audioSettings['enable-audio'] = (player.config && player.config['enable-audio']) ? player.config && player.config['enable-audio'] : false
      audioSettings['audio-power-save'] = (player.config && player.config['audio-power-save']) ? player.config && player.config['audio-power-save'] : false
      audioSettings['audio-output'] = (player.config && player.config['audio-output']) ? player.config && player.config['audio-output'] : 'hdmi'

      audioSummary.push(JSON.stringify(audioSettings))

      this.showAudioOptionProp = false
      this.selectedAudioVal = null
      if (audioSummary.length === 1) {
        this.showAudioOptionProp = true
        this.selectedAudioVal = audioSummary[0]
      } else if (audioSummary.length > 1) {
        const theSameAudioData = audioSummary.every((conf) => { return conf === audioSummary[0] })

        if (theSameAudioData) {
          this.showAudioOptionProp = true
          this.selectedAudioVal = audioSummary[0]
        }
      }

      // Set Audio Default value and Options for group B
      const allGroupBPlayers = groupBPlayerType.indexOf(player.deviceType) >= 0 ? [groupBPlayerType[groupBPlayerType.indexOf(player.deviceType)]] : []
      if (allGroupBPlayers.length) {
        const audioValIdsSummary = []
        allGroupBPlayers.forEach((player) => {
          if (player.audioInfo) {
            player.audioInfo.sort()
            let audioId = ''
            player.audioInfo.forEach((audio, indx) => { audioId += `${audio.id}, ` })
            audioValIdsSummary.push(audioId)
          } else {
            audioValIdsSummary.push(null)
          }
        })

        const allOptionsAreTheSame = audioValIdsSummary.every((audioId) => { return audioId === audioValIdsSummary[0] })
        const allAudioValueTheSame = allGroupBPlayers.every((player) => { return (player.config && allGroupBPlayers[0].config) && (player.config['audio-output'] === allGroupBPlayers[0].config['audio-output']) })

        if (allOptionsAreTheSame && allAudioValueTheSame) {
          const audioOptions = this.$utils.clone(this.audioOptions)
          audioOptions.optionsB = (allGroupBPlayers[0] && allGroupBPlayers[0].audioInfo) ? allGroupBPlayers[0].audioInfo.filter((audio) => { return audio.name }) : []
          const newSelectedAudioVal = allGroupBPlayers[0].config['audio-output']

          // Add None Option
          if (audioOptions.optionsB.length || newSelectedAudioVal) {
            const noneOption = {
              available: '',
              desc: '',
              id: false,
              name: 'none'
            }
            audioOptions.optionsB.push(noneOption)
          }

          this.audioOptions = audioOptions
          this.showAudioOptionProp = true
          this.audioOptionsKey = 'optionsB'
          this.selectedAudioVal = newSelectedAudioVal
        }
      }

      // Set Default value content
      this.showAudioOptionContent = false
      this.showResolutionOptionContent = false
      this.audioTitle = this.$t('label.audio')
      this.resolutionDefaultValContent = 'none'
      this.audioDefaultValContent = 'none'

      // Resolution
      if (this.showResolutionOptionProp) {
        const currentResOptions = this.resolutionOptions[this.resolutionOptionsKey]
        const getResolution = this.selectedResolution

        if (getResolution) {
          const findResTitle = currentResOptions.find((option) => { return option.value === getResolution })
          this.resolutionDefaultValContent = findResTitle.label
        }

        // Set default
        if (!getResolution) {
          if (this.resolutionOptionsKey === 'optionsA') {
            const findResTitle = currentResOptions.find((option) => { return option.value === '1920x1080' })
            this.resolutionDefaultValContent = findResTitle.label
          }

          if (this.resolutionOptionsKey === 'optionsB') {
            const findResTitle = currentResOptions.find((option) => { return option.value === '3840x2160' })
            this.resolutionDefaultValContent = findResTitle.label
          }
        }
      }

      // Audio
      if (this.showAudioOptionProp) {
        let getAudio = this.selectedAudioVal

        if (getAudio) {
          const findResTitle = this.audioOptions[this.audioOptionsKey].find((option) => { return option.value === getAudio || option.id === getAudio })
          let audioDefaultValContent = 'none'

          if (findResTitle && (findResTitle.label || findResTitle.name)) {
            audioDefaultValContent = findResTitle.label || findResTitle.name
            if (audioDefaultValContent === 'line-out') getAudio = getAudio.replace('-', ' ')
          }

          this.audioDefaultValContent = audioDefaultValContent
        }

        // Set default
        if (!getAudio) {
          this.audioDefaultValContent = 'none'
        }
      }

      this.compareResolutionFromLedDimension({ tags: this.playerNormalTags.concat(this.playerLEDTags) })
    },
    compareResolutionFromLedDimension (params) {
      const currentResolution = this.selectedResolution
      const res = {
        smallerThanLedDimension: false,
        resolutionValue: this.selectedResolution
      }
      this.hideResolutionLessThanLedDimension = false

      /*
        Hide the RESOLUTION entry
        If the resolution was set to a size smaller then the LED size, update it.
        - Resolution was set to 720, and the LED:widthxheight width is bigger than 1280 or the height is bigger then 720, then automatically switch to 1080
        - Resolution was set to HD, and the LED:widthxheight width is bigger than 1920 or the height is bigger then 1080, then automatically switch to 4K
          Update the Resolution tag to use “720p” and “1080p” as label otherwise.
      */
      const getLEDTAG = params.tags.find((tag) => { return tag.includes('LED:') })
      if (getLEDTAG) {
        const ledWidth = getLEDTAG.substr(4).split('x')[0]
        const ledHeight = getLEDTAG.substr(4).split('x')[1]
        let currentResolutionWidth = 0
        this.hideResolutionLessThanLedDimension = true

        if (currentResolution) {
          currentResolutionWidth = currentResolution.split('x')[0]

          if (parseInt(ledWidth) > parseInt(currentResolutionWidth) || parseInt(ledHeight) > parseInt(currentResolutionWidth)) {
            res.smallerThanLedDimension = true
            this.hideResolutionLessThanLedDimension = true
          }
        }
      } else {
        this.hideResolutionLessThanLedDimension = false
      }

      return res
    },
    filterPlayers (playersSrc = []) {
      const players = []

      for (const player of playersSrc) {
        player._edit = player?._edit ?? {}

        player._edit.status = this.getPlayerStatus(player)

        if (player.geoInfo && (player.geoInfo.latitude && player.geoInfo.longitude)) {
          // Add formatted address (Street-number Street-name city ZIP Country)
          let formattedAddress = (player.geoInfo.streetNumber) ? player.geoInfo.streetNumber : ''

          if (player.geoInfo.street) {
            formattedAddress += ` ${player.geoInfo.street}`
          }

          if (player.geoInfo.city) {
            formattedAddress += ` ${player.geoInfo.city}`
          }

          if (player.geoInfo.postalCode) {
            formattedAddress += ` ${player.geoInfo.postalCode}`
          }

          if (player.geoInfo.countryName) {
            formattedAddress += ` ${player.geoInfo.countryName}`
          }

          player._edit.address = formattedAddress
          player._edit.uid = this.$utils.generateUniqueID()

          players.push(player)
        }
      }

      return players
    },
    async getPlayers (params, callback = null) {
      if (!params) params = {}

      if (this.$route.params.monitoringOptions) {
        params.opt = this.$route.params.monitoringOptions
      }
      await this.loadAllPlayers(params);
      if (callback) {
        callback();
      }
    },
    getTagsSummary (params) {
      if (!params) params = {}

      this.$utils.mainLoader(true)
      const getTagsRequest = () => {
        this.$api.get(`${CONFIG.API_BASE_URL}/group/tags/?type=playerTags&ext=1`)
          .then(response => {
            const responseData = response.data
            this.playerTags = this.$utils.filterTagOptionsForUI({ tags: responseData })
            this.tagsSummary = this.playerTags
            this.doneFetchingTags = true

            if (params.callback) {
              params.callback()
            } else {
              this.$utils.mainLoader(false)
            }
          })
          .catch((error) => {
            this.$apiError.handleUnauthorizedError(error, { originalRequest: () => { getTagsRequest() } })
          })
      }
      getTagsRequest()
    },
    updatePlayer (params) {
      const putPayload = params.payload

      const apiRequest = () => {
        this.$utils.mainLoader(true)
        this.$api.put(`${CONFIG.API_BASE_URL}/player/${params.serialNumber}`, putPayload)
          .then(response => {
            const updatedPlayer = response.data
            const updateAllPlayers = this.$utils.updateItemFromList(this.$utils.clone(this.allPlayers), updatedPlayer, 'serialNumber')
            const updatePlayersToShow = this.$utils.updateItemFromList(this.$utils.clone(this.playersToShow), updatedPlayer, 'serialNumber')
            // Update the players list in the store
            this.updatePlayersList(updateAllPlayers);
            this.playersToShow = this.filterPlayers(updatePlayersToShow)
            this.$nextTick(_ => {
              this.playersAddressChangedProp = { ref: this.$utils.generateUniqueID(), player: updatedPlayer }
            })

            const updatedPlayerInfo = this.allPlayers.find((p) => { return p.serialNumber === this.selectedMarker.markerData.playersInfo.serialNumber })
            const selectedMarker = this.$utils.clone(this.selectedMarker)
            selectedMarker.markerData.playersInfo = updatedPlayerInfo

            this.selectedMarker = selectedMarker
            document.getElementById('playersAddressSearchBox').value = ''
            this.showPlayersAddressSearchBox = false

            this.$utils.mainLoader(false)
          })
          .catch((error) => {
            this.$utils.mainLoader(false)
            this.$apiError.handleAPIRequestError(error, { originalRequest: () => { apiRequest() }, showDialogNotification: true })
          })
      }

      apiRequest()
    },
    createVisibleMarkersSummary (params) {
      if (!params) params = {}
      const countVisiblePlayersStatusIcon = this.$utils.clone(this.countVisiblePlayersStatusIcon)
      countVisiblePlayersStatusIcon.summary.green = null
      countVisiblePlayersStatusIcon.summary.orange = null
      countVisiblePlayersStatusIcon.summary.red = null
      countVisiblePlayersStatusIcon.hasSelectedMarker = false

      if (params.markerSelected) {
        countVisiblePlayersStatusIcon.hasSelectedMarker = true
      }

      const playerSummaryList = (params.visibleMarkers && params.visibleMarkers.players.list) ? this.$utils.clone(params.visibleMarkers.players.list) : []
      this.visiblePlayersInMap = playerSummaryList

      // Create icon for players status
      if ((params.visibleMarkers && params.visibleMarkers.playerGroupByColor) && (playerSummaryList.length > 1)) {
        for (const statusAsIndex in params.visibleMarkers.playerGroupByColor) {
          const statusGrouped = params.visibleMarkers.playerGroupByColor[statusAsIndex]
          const createCustomIconParams = {
            fillColor: statusGrouped.iconProp.fillColor,
            strokeColor: statusGrouped.iconProp.strokeColor,
            textColor: '#000000',
            text: statusGrouped.players.length,
            groupIcon: true,
            width: '100%',
            height: '100%'
          }

          const createGroupIconByStatus = getCustomIconUrl(createCustomIconParams)

          createCustomIconParams.backgroundWithOpacity = { opacity: '0.2', fillColor: statusGrouped.iconProp.fillColor }
          const createGroupIconByStatusWithBackground = getCustomIconUrl(createCustomIconParams)
          const statusIcon = {
            status: statusAsIndex,
            iconSrcDefault: createGroupIconByStatus,
            iconSrcSelected: createGroupIconByStatusWithBackground,
            iconSrc: createGroupIconByStatus,
            selected: false
          }

          // Keep filter selection
          if (this.filterPlayerByIconColor === statusAsIndex) {
            statusIcon.selected = true
            statusIcon.iconSrc = createGroupIconByStatusWithBackground
          }

          countVisiblePlayersStatusIcon.summary[statusIcon.status] = statusIcon
        }
      }

      this.countVisiblePlayersStatusIcon = countVisiblePlayersStatusIcon
      this.countVisiblePlayers = params.visibleMarkers.players.list.length
    },
    handleTagSliderChange ($event) {
      if ($event.action === CONST.EMIT_EVENT_NEW_SELECTED_TAGS_FROM_SLIDER) {
        window.setTimeout(() => {
          this.filterPlayerByIconColor = false
          this.handleSearchConfirmation({ showAllPlayers: !$event.payload.data.length })
        }, 2) // Added timeout to make sure localStorage is updated
      } else if ($event.action === CONST.EMIT_EVENT_ALL_TAG_SELECTED_FROM_SLIDER) {
        this.filterPlayerByIconColor = false
        this.handleSearchConfirmation({ showAllPlayers: true })
      }
    },
    handleSearchConfirmation (params = {}) {
      this.prevPlayerSearchText = this.playerSearchTextVal // Keep previous search and compare from current search

      const selectedTagsFromSlider = this.$dataStore.getStore().selectedTagsFromSlider ? this.$dataStore.getStore().selectedTagsFromSlider : {}
      let tags = (selectedTagsFromSlider.monitoringPage && selectedTagsFromSlider.monitoringPage.length) ? selectedTagsFromSlider.monitoringPage : []
      // Make sure selected tags from localStorage exist in current player tags
      tags = tags.filter((selectedTag) => {
        return (this.playerTags.find((t) => { return t.value === selectedTag }))
      })
      const searchText = this.playerSearchTextVal.trim()
      const searchByName = searchText.length > 0
      const searchByNameAndTags = searchText.length > 0 && tags.length > 0
      const searchByTags = (searchText.length === 0 && tags.length > 0)
      const hasMultiTagSelection = tags.length > 1
      const hasSingleTagSelection = tags.length === 1
      const allPlayers = this.$utils.clone(this.allPlayers)
      let preflightSearchResults = []

      for (const indx in allPlayers) {
        const playerItem = allPlayers[indx]
        const playerIncludesName = playerItem.name.toLowerCase().includes(searchText.toLowerCase())
        const playerIncludesSerialNumber = playerItem.serialNumber.includes(searchText)
        let playerIncludesTag = false

        // Check tags
        if (!playerItem.tags) playerItem.tags = []

        if (hasMultiTagSelection) {
          playerIncludesTag = tags.every((selectedTag) => { return playerItem.tags.includes(selectedTag) })
        } else if (hasSingleTagSelection) {
          for (const indx in playerItem.tags) {
            if (tags[0] === playerItem.tags[indx]) {
              playerIncludesTag = true
              break
            }
          }
        } else {
          playerIncludesTag = false
        }

        let addToResult = false

        if (searchByName && (playerIncludesName || playerIncludesSerialNumber)) { // Search by name
          addToResult = true
        } else if (searchByTags && playerIncludesTag) {
          addToResult = true
        } else if (searchByNameAndTags && (playerIncludesName && playerIncludesTag)) {
          addToResult = true
        }

        if (addToResult) {
          preflightSearchResults.push(playerItem)
        }
      }

      if (!searchByName && !searchByTags) {
        preflightSearchResults = allPlayers
      }

      if (!preflightSearchResults.length && params.componentFirstLoad) {
        preflightSearchResults = allPlayers
        const selectedTagsFromSlider = this.$dataStore.getStore().selectedTagsFromSlider ? this.$dataStore.getStore().selectedTagsFromSlider : {}
        selectedTagsFromSlider.monitoringPage = []
        this.$dataStore.setStore({ selectedTagsFromSlider })
        this.tagsSelectionRequest = { ref: this.$utils.generateUniqueID(), tags: [] }
      }

      if (this.filterPlayerByIconColor) {
        const filterByStatus = preflightSearchResults.filter((player) => { return player._edit.status.status === this.filterPlayerByIconColor })
        preflightSearchResults = filterByStatus
      }

      // Clear filters if show all players
      if (params.showAllPlayers) {
        this.filterPlayerByIconColor = false
        this.$nextTick(_ => {
          this.playersToShow = allPlayers
          this.playerSearchTextVal = ''
          this.showSearchInput = false
          $('#monitoringSearchPlacesInput').val('')
        })
      } else {
        // Search to the backend if empty result from the frontend
        if (preflightSearchResults.length) {
          this.playersToShow = preflightSearchResults
          this.$utils.mainLoader(false)
        } else {
          const reqParams = {}
          if (searchText !== '') {
            reqParams.search = searchText;
          }
          this.pullPlayersSearchResults(reqParams);
        }
      }
    },
    async pullPlayersSearchResults (params) {
      this.playersToShow = this.filterPlayers(await this.loadAllPlayers(params))
    },
    handleSearhOptionOnBlur () {
      const self = this
      $('#monitoringPage').on('click', (e) => {
        const targetElement = $(e.target)
        const preventConfirmedSearch = targetElement.hasClass('prevent-confirmed-search')
        const forceToCloseSearchOption = targetElement.hasClass('player-item-cover')
        const targetSearch = self.showSearchInput && !preventConfirmedSearch && !forceToCloseSearchOption

        if (targetSearch && this.prevPlayerSearchText !== this.playerSearchTextVal) {
          if (!this.playerSearchTextVal.trim()) {
            this.showSearchInput = false
          }

          self.handleSearchConfirmation({ inputAction: 'onBlur' })
        } else if (targetSearch && (this.prevPlayerSearchText === '' && this.prevPlayerSearchText === this.playerSearchTextVal)) {
          self.handleSearchConfirmation({ inputAction: 'onBlur' })
          this.showSearchInput = false
        }
      })
    },
    onEnter (event) {
      if (event.target.id === 'player-monitoring-search') {
        this.handleSearchConfirmation('onEnter')
      }
    }
  },
  mounted () {
    this.isAuthenticated({
      callback: () => {
        this.getTagsSummary({
          callback: async () => {
            await this.getPlayers(
              {},
              () => {
                this.handleSearchConfirmation({ componentFirstLoad: true })
                this.$utils.updatePageComponentStyle({ name: 'monitoringPage' })
              })
          }
        })
      }
    })

    $(window).on('resize', () => { this.$utils.updatePageComponentStyle({ name: 'monitoringPage' }) })
    this.handleSearhOptionOnBlur()
  }
}
